
import React, { useState, useEffect, useCallback } from 'react';
import Layout from './components/Layout';
import Slide from './components/Slide';
import { SLIDES } from './constants';

const App: React.FC = () => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const nextSlide = useCallback(() => {
    setCurrentSlideIndex((prev) => Math.min(prev + 1, SLIDES.length - 1));
  }, []);

  const prevSlide = useCallback(() => {
    setCurrentSlideIndex((prev) => Math.max(prev - 1, 0));
  }, []);

  const goToSlide = useCallback((index: number) => {
    setCurrentSlideIndex(index);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight' || e.key === ' ') {
        nextSlide();
      } else if (e.key === 'ArrowLeft') {
        prevSlide();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [nextSlide, prevSlide]);

  const currentSlide = SLIDES[currentSlideIndex];

  return (
    <Layout
      currentSlide={currentSlideIndex}
      totalSlides={SLIDES.length}
      onNext={nextSlide}
      onPrev={prevSlide}
      onGoTo={goToSlide}
      speakerNotes={currentSlide.speakerNotes}
    >
      <div className="h-full w-full animate-in fade-in zoom-in-95 duration-500 ease-out" key={currentSlideIndex}>
        <Slide data={currentSlide} />
      </div>
    </Layout>
  );
};

export default App;
